module.exports = __webpack_public_path__ + "img/sortable.b6268a5f.svg";